var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTbActivityHeartBeat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    stroke: "currentColor",
    fill: "none",
    strokeWidth: 2,
    viewBox: "0 0 24 24",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    height: "200px",
    width: "200px",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 12h4.5l1.5 -6l4 12l2 -9l1.5 3h4.5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTbActivityHeartBeat);
export default __webpack_public_path__ + "static/media/TbActivityHeartBeat.e22c4a4df4588b6315db2dc49fdbfe12.svg";
export { ForwardRef as ReactComponent };